import {
  FETCH_STANDARD_REPORTS,
  FETCH_COMPARISON_REPORTS,
  FETCH_Z_REPORTS,
  FETCH_DASHBOARD_REPORTS,
  FETCH_DASHBOARD_PRODUCTS,
  FETCH_DASHBOARD_CATEGORIES,
} from '../actions/types';

export default function reportReducer(state = { items: [] }, action) {
  switch (action.type) {
    case FETCH_Z_REPORTS:
      return { ...state, zReports: action.payload };
    case FETCH_STANDARD_REPORTS:
      return { ...state, standard: action.payload };
    case FETCH_COMPARISON_REPORTS:
      return { ...state, comparisonReports: action.payload };
    case FETCH_DASHBOARD_REPORTS:
      return { ...state, dashboard: action.payload };
    case FETCH_DASHBOARD_PRODUCTS:
      return { ...state, dashboardProducts: action.payload };
    case FETCH_DASHBOARD_CATEGORIES:
      return { ...state, dashboardCategories: action.payload };
    default:
      return state;
  }
}